import { render } from "./ViewSwitcher.vue?vue&type=template&id=ea97a282"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__